import React from 'react';
import { isMobile } from 'react-device-detect';
import CardPosts from '../CardPosts';
import './SharingOptions.scss';

function SharingOptions({ link, handleShare }) {
  return (
    <CardPosts title="Compartir" height="share">
      <div className="sharing-options-content">
        <div className="sharing-options-icon">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${link}`}
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={handleShare}
          >
            <img src="/img/articles/share/facebook.svg" alt="icono facebook" />
          </a>
        </div>
        <div className="sharing-options-icon">
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${link}`}
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={handleShare}
          >
            <img src="/img/articles/share/linke-in.svg" alt="icono linkedin" />
          </a>
        </div>
        <div className="sharing-options-icon">
          <a
            className="twitter-share-button"
            href={`https://twitter.com/intent/tweet?&url=${link}`}
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={handleShare}
          >
            <img src="/img/articles/share/twitter.svg" alt="icono twitter" />
          </a>
        </div>
        <div className="sharing-options-icon">
          <a
            href={`https://api.whatsapp.com/send?text=${link}`}
            data-action="share/whatsapp/share"
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={handleShare}
          >
            <img src="/img/articles/share/whatsapp.svg" alt="icono whatsapp" />
          </a>
        </div>
        {isMobile && (
          <div className="sharing-options-icon">
            <a href={`fb-messenger://share/?link=${link}`} onClick={handleShare}>
              <img
                src="/img/articles/share/messenger.svg"
                alt="icono messenger nofollow"
              />
            </a>
          </div>
        )}
      </div>
    </CardPosts>
  );
}

export default SharingOptions;
